import flatpickr from "flatpickr/dist/flatpickr";
import { French } from "flatpickr/dist/l10n/fr";

export class Search {
  constructor(el) {
    Object.assign(this, {
      el: el,
      hasReset: true,
      queryDates: [1, new Date().getTime()],
    });

    this.participants = Array.from(
      this.el.querySelectorAll("[data-participant]")
    );

    // this.query_participants = this.el.querySelector("[data-query-participants]");

    this.query = this.el.querySelector("[data-query]");
    this.dates = this.el.querySelector("[data-dates]");
    this.btClear = this.el.querySelector("[data-clear]");
    this.el.addEventListener("submit", this.onSubmit.bind(this));
    this.query.addEventListener("keyup", this.onChange.bind(this));

    if (this.btClear) {
      this.btClear.addEventListener("click", () => {
        this.reset(true);
      });
    }

    const lang = document.documentElement.getAttribute("lang");
    if (this.dates) 
    {
      this._picker = flatpickr(this.dates, {
        locale: lang == "fr" ? French : null,
        mode: "range",
        // maxDate: "today",
          onChange: (dates, dateStr, instance) => {
            if (dates.length == 2) {
              const dateStart = new Date(dates[0]);
              const dateEnd = new Date(
                String(dates[1]).replace("00:00:00", "23:59:59")
              );
              this.queryDates = [dateStart.getTime(), dateEnd.getTime()];
              this.filter();
            } else {
              this.queryDates = [1, new Date().getTime()];
            }
          },
          });
    }

    this.reset();
  }

  onChange(e) {
    const query = this.query.value.toLowerCase();
    if (query.length > 1) {
      this.filter();
      this.hasReset = false;
    } else if (!this.hasReset) {
      this.reset();
    }
  }

  filter() {
    const query = this.query.value.toLowerCase();
    console.log(this.queryDates);
    
    this.participants.forEach((participant) => {

      const participantName = participant.dataset.participant;
      const participantDate = participant.dataset.date;


      if (
        (query.length > 1 && participantName.indexOf(query) === -1) ||
        !this.inRange(participantDate)
      ) {
        participant.style.display = "none";
      } else {
        participant.style.display = "block";
      }
    });
  }

  inRange(date) {
    //const time = new Date(date).getTime();
    const time = new Date(date).getTime();


      if (isNaN(time)) {
          return true;
        }

    console.log(time);
    if ( !this.queryDates ) {
        this.queryDates = [1, new Date().getTime()];
    }

    if (time < this.queryDates[0] || time > this.queryDates[1]) {
      return false;
    } else {
      return true;
    }
  }

  reset(clearFields) {
    this.participants.forEach((participant) => {
      participant.style.display = "block";
    });

    if (clearFields) {
      this.query.value = "";
      this._picker.clear();
    }
    this.hasReset = true;
  }

  onSubmit(e) {
    return false;
  }
}
